export default __webpack_public_path__ + "static/media/octogono-large.9cd7ab3d.png";